import { logger } from '@disy/lib/logging';

import { alert, confirm } from 'cadenza/alert';
import type { TimelinesDto } from 'cadenza/api-client/timeline-dto';
import i18n from 'cadenza/map/timeline-visualization/load-timelines.properties';
import { getStore } from 'cadenza/store/cadenza-store';
import { closeTimelinePlayer, setTimelinePlayerTimelines } from 'cadenza/workbook/timelines/timeline.state';

type TimelineLoader = (allowLargeData: boolean) => Promise<TimelinesDto>;

export function loadTimelines(timelineLoader: TimelineLoader) {
  const listAndApplyTimelines = (allowLargeData = false) => {
    timelineLoader(allowLargeData)
      .then((timelinesDto) => {
        getStore().dispatch(setTimelinePlayerTimelines(timelinesDto));
      })
      .catch((error) => {
        if (error.key === 'point-count-warning') {
          return confirm(error.title, error.detail, {
            // NOSONAR because not a native confirm
            type: 'warning',
            submit: i18n('continue.button.label'),
          })
            .then((confirmed) => {
              if (confirmed) {
                return listAndApplyTimelines(true);
              } else {
                // User rejects playing due to too many points in timeline, we close the player
                return getStore().dispatch(closeTimelinePlayer());
              }
            })
            .catch((err) => logger.error('Failed to load timelines', err));
        } else {
          if (['point-count-error', 'insufficient-point-count', 'point-requirement-error'].includes(error.key)) {
            alert(error.title, error.detail, { type: 'info' }); // NOSONAR not a native alert
          } else if (error.name !== 'AbortError') {
            logger.error('Failed to load timelines', error);
          }
          return getStore().dispatch(closeTimelinePlayer());
        }
      });
  };

  listAndApplyTimelines();
}
